import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Container, Heading, Text, Button, VStack, HStack, Icon } from "@chakra-ui/react";
import { FaHome, FaPhoneAlt } from "react-icons/fa";
import { GiScales } from "react-icons/gi";

export default function NotFound() {
    return (
        <Box
            bg="#070d1e"
            color="white"
            minH="100vh"
            display="flex"
            alignItems="center"
            justifyContent="center"
            position="relative"
            overflow="hidden"
            px={4}
        >
            {/* Background subtle radial aura */}
            <Box
                position="absolute"
                top="30%"
                left="50%"
                transform="translate(-50%, -50%)"
                w="600px"
                h="600px"
                borderRadius="full"
                bg="radial-gradient(circle, rgba(223, 186, 115, 0.08) 0%, rgba(11, 19, 43, 0) 70%)"
                pointerEvents="none"
            />

            <Container maxW="container.md" textAlign="center" position="relative" zIndex={2}>
                <VStack spacing={6}>
                    <Box
                        w="80px"
                        h="80px"
                        borderRadius="2xl"
                        bg="linear-gradient(135deg, rgba(223, 186, 115, 0.2) 0%, rgba(197, 168, 128, 0.05) 100%)"
                        border="1px solid rgba(223, 186, 115, 0.3)"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        color="#dfba73"
                        boxShadow="0 10px 30px rgba(0, 0, 0, 0.4)"
                    >
                        <Icon as={GiScales} fontSize="40px" />
                    </Box>

                    <Heading
                        fontSize={{ base: "6rem", md: "9rem" }}
                        fontWeight="900"
                        lineHeight="1"
                        letterSpacing="tight"
                        bgGradient="linear(to-b, #dfba73, #947138)"
                        bgClip="text"
                    >
                        404
                    </Heading>

                    <Heading fontSize={{ base: "2xl", md: "3xl" }} fontWeight="800">
                        Էջը չի գտնվել
                    </Heading>

                    <Text color="gray.400" fontSize={{ base: "md", md: "lg" }} maxW="500px">
                        Ձեր փնտրած էջը հնարավոր է տեղափոխվել է կամ այլևս հասանելի չէ։ Ստուգեք հասցեն կամ վերադարձեք գլխավոր էջ։
                    </Text>

                    <HStack spacing={4} pt={4} flexWrap="wrap" justify="center">
                        <Button
                            as={RouterLink}
                            to="/"
                            leftIcon={<FaHome />}
                            bg="#dfba73"
                            color="#070d1e"
                            fontWeight="800"
                            px={8}
                            py={6}
                            borderRadius="full"
                            _hover={{
                                bg: "#f0cf8e",
                                transform: "translateY(-2px)",
                                boxShadow: "0 10px 25px rgba(223, 186, 115, 0.35)",
                            }}
                            transition="all 0.3s ease"
                        >
                            Գլխավոր էջ
                        </Button>
                        <Button
                            as={RouterLink}
                            to="/connect"
                            leftIcon={<FaPhoneAlt />}
                            variant="outline"
                            borderColor="rgba(255, 255, 255, 0.2)"
                            color="white"
                            px={8}
                            py={6}
                            borderRadius="full"
                            _hover={{
                                bg: "rgba(255, 255, 255, 0.08)",
                                borderColor: "#dfba73",
                                color: "#dfba73",
                            }}
                            transition="all 0.3s ease"
                        >
                            Կապ մեզ հետ
                        </Button>
                    </HStack>
                </VStack>
            </Container>
        </Box>
    );
}
